import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';

import {LpHoldingReqRes} from '../../../lp-holdings/LpHoldingReqRes.model';
import HoldingDiscriminator from '../../../../shared/enums/HoldingDiscriminator.enum';
import {ImpersonationService} from '../../../../services/shared/impersonation.service';
import {LpHoldingListItemReqRes} from '../LpHoldingListItemReqRes.model';

@Component({
  selector: 'terra-private-holding-notification',
  templateUrl: './private-holding-notification.component.html',
  styleUrls: ['./private-holding-notification.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PrivateHoldingNotificationComponent implements OnInit {
  @Input() holding: LpHoldingReqRes | LpHoldingListItemReqRes;
  constructor(private impersonationService: ImpersonationService) { }

  ngOnInit(): void {
  }

  get isViewingAsInvestor(): boolean {
    return this.impersonationService.isViewingAsInvestor;
  }

  get holdingTypeStr(): string {
    return this.holding.discriminator === HoldingDiscriminator.Asset ? 'asset' : 'fund';
  }
}
